// Enum for logical unit types avec labels multilingues
export const U3141ChildLotStateEnum = [
  {
    value: "importValidate",
    label: {
      fr: "Registre foncier",
      en: "Land registry",
    },
  },
  {
    value: "importNotValidate",
    label: {
      fr: "Saisi manuellement",
      en: "Manually Entered",
    },
  },
];
